import cookies from './utils/cookies';
// Keep in sync with CookieService.
const localeCookieName = 'preferred_locale';

const ruUriPrefix = '';
// Sorted by popularity (clicks)
const allowedPrefixes = ['en', 'de', 'uk', 'pl', 'tr', 'fr', 'es', 'pt', 'ro', 'el', 'cs', 'it', 'hu'];

const allLocales = ['ru', 'en', 'de', 'uk', 'pl', 'tr', 'fr', 'es', 'pt', 'ro', 'el', 'cs', 'it', 'hu'];

let pathArray = window.location.pathname.split('/');
const prefixIndex = 1;
let currentPrefix;
if (pathArray[prefixIndex] !== undefined && allowedPrefixes.includes(pathArray[prefixIndex])) {
    currentPrefix = pathArray[prefixIndex];
} else {
    currentPrefix = ruUriPrefix;
}

// Prefix to locale map (empty prefix = ru)
const prefixToLocaleMap = Object.fromEntries([
    [ruUriPrefix, 'ru'],
    ...allowedPrefixes.map(p => [p, p])
]);

let currentLocale = prefixToLocaleMap[currentPrefix];

// Preferred locale by user.
const storedPreferredLocale = cookies.get(localeCookieName);

// Preferred language from browser.
const preferredLang = (window.navigator.language || '').toLowerCase();

let proposalLocale;
if (storedPreferredLocale) {
    proposalLocale = storedPreferredLocale
} else {
    proposalLocale = allLocales.find(locale => preferredLang.startsWith(locale)) || null;
}

if (storedPreferredLocale && currentLocale === storedPreferredLocale) {
    // Если уже выбирал локаль и она совпадает с текущей, то не показываем баннер.
    proposalLocale = null;
} else if (!storedPreferredLocale && proposalLocale === currentLocale) {
    // Если не выбирал локаль и браузер предпочитает текущую локаль, то не показываем баннер.
    proposalLocale = null;
}

const languageBar = document.querySelector('.lang-banner');
const languageProposal = languageBar?.querySelector(`#language-proposal-${proposalLocale}`);
if (languageBar && languageProposal) {
    languageProposal.classList.remove('hidden');
    languageBar.classList.remove('hidden');
    // window.scrollTo({ top: 0, behavior: 'smooth' });

    const barDismissHandler = function (event) {
        event.preventDefault();

        // Set current locale as preferred.
        cookies.set(localeCookieName, currentLocale, 365);

        // Remove language bar.
        languageBar.remove();

        // Send event to Google Analytics.
        gtag('event', 'keep_current_language', {
            'event_category': 'Language Proposal',
            'event_label': 'Keep Current',
            'current_language': currentLocale,
        });
    };

    const languageChangeHandler = function (event) {
        event.preventDefault();

        // Set proposal locale as preferred.
        cookies.set(localeCookieName, proposalLocale, 365);

        // Remove language bar.
        languageBar.remove();

        // Send event to Google Analytics.
        gtag('event', 'change_current_language', {
            'event_category': 'Language Proposal',
            'event_label': 'Change Current',
            'new_language': proposalLocale,
        });

        // Get URL from the link.
        const url = this.getAttribute('href');

        setTimeout(function () {
            window.location.href = url;
        }, 200);
    };

    languageProposal
        .querySelector('.keep-site-language')
        .addEventListener('click', barDismissHandler);

    languageProposal
        .querySelector('.switch-site-language')
        .addEventListener('click', languageChangeHandler);
}
// Also change cookie on language switch.
const links = document.querySelectorAll('.nav-dd-menu a[data-locale], .language-switcher ul li a');

links.forEach(function (link) {
    link.addEventListener('click', function (event) {
        event.preventDefault();

        // Set selected locale as preferred.
        const locale = this.getAttribute('data-locale');
        cookies.set(localeCookieName, locale, 365);

        // Send event to Google Analytics.
        gtag('event', 'change_language_via_menu', {
            'event_category': 'Menu',
            'event_label': 'Language Change',
            'new_language': locale,
        });

        // Get URL from the link.
        const url = link.getAttribute('href');

        setTimeout(function () {
            window.location.href = url;
        }, 200);
    });
});
